'use strict';

exports.__esModule = true;
exports['default'] = getDisplayName;

function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
}

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/redux-form/lib/getDisplayName.js
// module id = 555
// module chunks = 0